const buildCoasterProperties = (designs) => {
  const properties = [];
  let slot = 1;

  designs.forEach((design) => {
    const quantity = Number(design.quantity);
    for (let index = 0; index < quantity; index += 1) {
      properties.push({
        name: `properties[Coaster ${slot}]`,
        value: design.name,
      });
      slot += 1;
    }
  });

  return properties;
};

const coasterSetSizeForVariant = (variant) => {
  const values = [variant?.title, ...(variant?.options || [])].filter(Boolean);
  const match = values.map((value) => String(value).match(/\b([4-6])\s*coasters?\b/i)).find(Boolean);
  return match ? Number(match[1]) : null;
};

const defaultCoasterQuantities = (designCount, setSize = 4) => {
  if (!Number.isInteger(designCount) || designCount < 1 || ![4, 5, 6].includes(setSize)) return [];
  return Array.from({ length: designCount }, (_, index) => Math.floor(setSize / designCount) + (index < setSize % designCount ? 1 : 0));
};

const addCoasterToMix = (quantities) => {
  if (!quantities.length) return quantities;
  const lowest = Math.min(...quantities);
  const index = quantities.findIndex((quantity) => quantity === lowest);
  return quantities.map((quantity, position) => quantity + (position === index ? 1 : 0));
};

const removeCoasterFromMix = (quantities) => {
  if (!quantities.length) return quantities;
  const highest = Math.max(...quantities);
  const index = quantities.lastIndexOf(highest);
  return quantities.map((quantity, position) => quantity - (position === index ? 1 : 0));
};

const resizeCoasterMix = (quantities, setSize) => {
  let resizedQuantities = quantities;
  while (resizedQuantities.reduce((sum, quantity) => sum + quantity, 0) < setSize) resizedQuantities = addCoasterToMix(resizedQuantities);
  while (resizedQuantities.reduce((sum, quantity) => sum + quantity, 0) > setSize) resizedQuantities = removeCoasterFromMix(resizedQuantities);
  return resizedQuantities;
};

const normalizeFullWidthDigits = (value) => value.replace(/[０-９]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) - 0xff10 + 0x30));

const splitCharacters = (value) => {
  if (typeof Intl.Segmenter === 'function') {
    return Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), (segment) => segment.segment);
  }

  return Array.from(value);
};

const isWideNameGrapheme = (grapheme) => /[\u3000-\u303f\u3040-\u30ff\u3100-\u312f\u3130-\u318f\u31a0-\u31bf\u3200-\u32ff\u3400-\u4dbf\u4e00-\u9fff\uac00-\ud7af\uf900-\ufaff\ufe30-\ufe6f\uff00-\uffef]/u.test(grapheme)
  || /\p{Extended_Pictographic}|\p{Regional_Indicator}|\u20e3/u.test(grapheme);

const isAllowedPetNameGrapheme = (grapheme) => /^[\p{L}\p{M}0-9 '-]+$/u.test(grapheme);
const nameGraphemeUnits = (grapheme) => (isWideNameGrapheme(grapheme) ? 2 : 1);
const countPetNameUnits = (value) => splitCharacters(normalizeFullWidthDigits(value)).reduce(
  (units, grapheme) => units + nameGraphemeUnits(grapheme),
  0
);

const sanitizePetName = (value, unitLimit, characterMessage, limitMessage) => {
  let units = 0;
  let message = '';
  const sanitized = splitCharacters(normalizeFullWidthDigits(value)).filter((grapheme) => {
    if (!isAllowedPetNameGrapheme(grapheme)) {
      message ||= characterMessage;
      return false;
    }
    if (units + nameGraphemeUnits(grapheme) > unitLimit) {
      message ||= limitMessage;
      return false;
    }
    units += nameGraphemeUnits(grapheme);
    return true;
  }).join('');

  return { value: sanitized, message };
};

if (typeof window !== 'undefined') {
  window.floopiloV2BuildCoasterProperties = buildCoasterProperties;
  window.floopiloV2CoasterMix = { coasterSetSizeForVariant, defaultCoasterQuantities, addCoasterToMix, removeCoasterFromMix, resizeCoasterMix };
}

(() => {
  // Match the active Shopify 20% product discount's single-item cents, not a rounded 0.8x total.
  const holidayPriceCents = (cents) => {
    const base = Math.round(Number(cents));
    return base - Math.floor((base * 20) / 100);
  };
  const formatMoney = (cents, format, currency) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: currency || 'USD',
    }).format(cents / 100);
  };

  document.querySelectorAll('[data-floopilo-v2-product-form]').forEach((container) => {
    if (container.dataset.v2ProductFormInitialized === 'true') return;
    container.dataset.v2ProductFormInitialized = 'true';

    const form = container.querySelector('form');
    const errorSummary = container.querySelector('[data-v2-form-errors]');
    const variantInput = form.querySelector('[name="id"]');
    const variantSelect = form.querySelector('[data-v2-variant-select]');
    const price = container.querySelector('[data-v2-price]');
    const submitButton = form.querySelector('[type="submit"]');
    const submitText = submitButton.querySelector('span');
    const variantsElement = container.querySelector('[data-v2-variants]');
    const variants = variantsElement ? JSON.parse(variantsElement.textContent) : [];
    const mainImage = container.querySelector('[data-v2-main-image] img');
    const galleryThumbnails = container.querySelector('[data-v2-gallery-thumbnails]');
    const galleryPrevious = container.querySelector('[data-v2-gallery-previous]');
    const galleryNext = container.querySelector('[data-v2-gallery-next]');
    const gallery = container.querySelector('.floopilo-v2-product__gallery');
    const buttons = container.querySelector('.floopilo-v2-product__buttons');
    const purchasePanel = container.querySelector('.floopilo-v2-product__purchase-panel');
    const whyPanel = container.querySelector('.floopilo-v2-product__why');
    const galleriesElement = container.querySelector('[data-v2-design-galleries]');
    const designGalleries = galleriesElement ? JSON.parse(galleriesElement.textContent) : [];
    const gallerySlotsElement = container.querySelector('[data-v2-design-gallery-slots]');
    const designGallerySlots = gallerySlotsElement ? JSON.parse(gallerySlotsElement.textContent) : [];
    const selectedDesignName = container.querySelector('[data-v2-selected-design]');
    const designIdProperty = form.querySelector('[data-v2-design-id-property]');
    const petName = form.querySelector('[data-v2-field="pet-name"]');
    const petPhoto = form.querySelector('[data-v2-field="pet-photo"]');
    const petNameCounter = container.querySelector('[data-v2-name-counter]');
    const petPhotoStatus = container.querySelector('[data-v2-photo-status]');
    const largePhotoHint = container.querySelector('[data-v2-large-photo-hint]');
    const petPhotoPreviewImage = container.querySelector('[data-v2-photo-preview-image]');
    const petPhotoPlaceholder = container.querySelector('[data-v2-photo-placeholder]');
    const petPhotoCard = container.querySelector('[data-v2-photo-card]');
    const petPhotoFilename = container.querySelector('[data-v2-photo-filename]');
    const petPhotoChoose = container.querySelector('[data-v2-photo-choose]');
    const photoUpload = container.querySelector('[data-v2-photo-upload]');
    const photoGuideToggle = container.querySelector('[data-v2-photo-guide-toggle]');
    const photoGuide = container.querySelector('[data-v2-photo-guide]');
    const nameGuideToggle = container.querySelector('[data-v2-name-guide-toggle]');
    const nameGuide = container.querySelector('[data-v2-name-guide]');
    const nameFieldset = container.querySelector('.floopilo-v2-product__pet-name-fieldset');
    const petNameUnitLimit = Number.parseInt(petName?.dataset.v2NameUnitLimit || '12', 10);
    const photoMaxSize = 20 * 1024 * 1024;
    const largePhotoThreshold = 2.5 * 1024 * 1024;
    const allowedPhotoExtensions = new Set(['jpg', 'jpeg', 'png', 'webp', 'heic', 'heif']);
    const allowedPhotoMimeTypes = new Set([
      'image/jpeg', 'image/jpg', 'image/png', 'image/webp',
      'image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'image/x-heic', 'image/x-heif',
    ]);
    const genericMimeTypes = new Set(['', 'application/octet-stream', 'binary/octet-stream']);
    const isDesignMode = container.dataset.v2DesignMode === 'true';
    const isCoasterMix = container.dataset.v2ProductMode === 'coaster-mix';
    const designsConfigured = container.dataset.v2DesignsConfigured === 'true';
    const coasterDesigns = Array.from(container.querySelectorAll('[data-v2-coaster-design]'));
    const mixDesigns = container.querySelector('[data-v2-mix-designs]');
    const mixTotal = container.querySelector('[data-v2-mix-total]');
    const mixProperties = container.querySelector('[data-v2-mix-properties]');
    const coasterSetSelector = container.querySelector('[data-v2-coaster-set-selector]');
    const coasterSetOptions = Array.from(container.querySelectorAll('[data-v2-coaster-set-option]'));
    const coasterVariantsBySize = new Map(
      variants.map((variant) => [coasterSetSizeForVariant(variant), variant]).filter(([setSize]) => setSize)
    );
    const hasCoasterSetVariants = [4, 5, 6].every((setSize) => coasterVariantsBySize.has(setSize));
    const defaultMainImage = mainImage ? {
      src: mainImage.src,
      srcset: mainImage.getAttribute('srcset'),
      alt: mainImage.alt,
      fit: mainImage.style.objectFit,
      position: mainImage.style.objectPosition,
      sizes: mainImage.getAttribute('sizes'),
    } : null;
    let activeGallery = [];
    let activeGallerySlots = [];
    let activeImageIndex = 0;
    let petPhotoPreviewUrl = '';
    let isComposingPetName = false;
    let petNameRejectionMessage = '';
    let coasterSetSize = hasCoasterSetVariants
      ? 4
      : coasterSetSizeForVariant(variants.find((item) => String(item.id) === variantInput.value)) || 4;

    const desktopLayout = window.matchMedia('(min-width: 750px)');
    const placeWhyPanel = () => {
      if (!whyPanel || !gallery || !buttons || !purchasePanel) return;

      if (desktopLayout.matches) gallery.append(whyPanel);
      else purchasePanel.after(whyPanel);
    };

    // Preserve native required-field validation when JavaScript is unavailable.
    form.noValidate = true;

    const clearFieldError = (field) => {
      const error = container.querySelector(`[data-v2-error-for="${field}"]`);
      if (error) error.hidden = true;
    };

    const showFieldError = (field, message) => {
      const inputs = form.querySelectorAll(`[data-v2-field="${field}"]`);
      const error = container.querySelector(`[data-v2-error-for="${field}"]`);
      inputs.forEach((input) => input.setAttribute('aria-invalid', 'true'));
      if (error) {
        error.textContent = message;
        error.hidden = false;
      }
    };

    const resetField = (field) => {
      form.querySelectorAll(`[data-v2-field="${field}"]`).forEach((input) => input.removeAttribute('aria-invalid'));
      clearFieldError(field);
    };

    const copy = (key, fallback) => container.dataset[key] || fallback;
    const petNameCharacterMessage = copy('v2ErrorNameCharacters', 'Use letters, numbers, spaces, hyphens, and apostrophes only.');
    const petNameLimitMessage = copy('v2ErrorNameLength', 'Pet names can use up to {count} units (12 English letters or 6 CJK characters).').replace('{count}', String(petNameUnitLimit));

    const updatePetNameCounter = () => {
      if (!petName || !petNameCounter) return;

      petNameCounter.textContent = `${countPetNameUnits(petName.value)}/${petNameUnitLimit}`;
    };

    const isPetNameTooLong = () => petName && countPetNameUnits(petName.value) > petNameUnitLimit;
    const hasInvalidPetNameCharacters = () => petName && splitCharacters(normalizeFullWidthDigits(petName.value)).some((grapheme) => !isAllowedPetNameGrapheme(grapheme));

    const updateSubmitAvailability = () => {
      const selectedVariant = variants.find((item) => String(item.id) === variantInput.value);
      const unavailable = !selectedVariant || !selectedVariant.available || !designsConfigured || isPetNameTooLong();

      submitButton.disabled = unavailable;
      submitButton.setAttribute('aria-disabled', String(unavailable));
    };

    const updatePetNameValidation = () => {
      updatePetNameCounter();
      if (!petName) return;

      const message = petNameRejectionMessage
        || (hasInvalidPetNameCharacters() ? petNameCharacterMessage : '')
        || (isPetNameTooLong() ? petNameLimitMessage : '');
      if (message) showFieldError('pet-name', message);
      else resetField('pet-name');
      petNameCounter.classList.toggle('is-invalid', Boolean(message));
      updateSubmitAvailability();
    };

    const normalizePetName = () => {
      if (!petName) return;

      const value = petName.value;
      const selectionStart = petName.selectionStart ?? value.length;
      const selectionEnd = petName.selectionEnd ?? selectionStart;
      const normalized = sanitizePetName(value, petNameUnitLimit, petNameCharacterMessage, petNameLimitMessage);

      petNameRejectionMessage = normalized.message;
      if (normalized.value !== value) {
        const normalizedStart = sanitizePetName(value.slice(0, selectionStart), petNameUnitLimit, petNameCharacterMessage, petNameLimitMessage).value.length;
        const normalizedEnd = sanitizePetName(value.slice(0, selectionEnd), petNameUnitLimit, petNameCharacterMessage, petNameLimitMessage).value.length;
        petName.value = normalized.value;
        petName.setSelectionRange(normalizedStart, normalizedEnd);
      }
      updatePetNameValidation();
    };

    const photoError = () => {
      if (!petPhoto.files || petPhoto.files.length !== 1) return copy('v2ErrorPhotoRequired', 'Choose one pet photo.');

      const [file] = petPhoto.files;
      const extension = file.name.split('.').pop().toLowerCase();
      const mimeType = file.type.toLowerCase();

      if (!allowedPhotoExtensions.has(extension)) return copy('v2ErrorPhotoType', 'Choose a JPG, PNG, WebP, HEIC, or HEIF photo.');
      if (!file.size) return copy('v2ErrorPhotoEmpty', 'Choose a photo file that is not empty.');
      if (file.size > photoMaxSize) return copy('v2ErrorPhotoSize', 'Choose a photo no larger than 20 MiB.');
      if (!genericMimeTypes.has(mimeType) && !allowedPhotoMimeTypes.has(mimeType)) {
        return copy('v2ErrorPhotoType', 'Choose a JPG, PNG, WebP, HEIC, or HEIF photo.');
      }

      return '';
    };

    const updatePetPhotoStatus = () => {
      const error = photoError();
      const chosenFile = petPhoto.files && petPhoto.files[0];
      if (largePhotoHint) largePhotoHint.hidden = Boolean(error) || !chosenFile || chosenFile.size <= largePhotoThreshold;

      if (petPhotoStatus) {
        petPhotoStatus.hidden = Boolean(error);
        petPhotoStatus.textContent = error ? '' : copy('v2PhotoSelectedLabel', 'Photo selected');
      }
      if (petPhotoCard) petPhotoCard.hidden = Boolean(error);
      if (petPhotoChoose) petPhotoChoose.hidden = !error;
      if (petPhotoFilename) petPhotoFilename.textContent = error ? '' : petPhoto.files[0].name;

      return error;
    };

    const updatePetPhotoPreview = () => {
      if (!petPhotoPreviewImage || !petPhotoPlaceholder) return;

      if (petPhotoPreviewUrl) URL.revokeObjectURL(petPhotoPreviewUrl);
      petPhotoPreviewUrl = '';
      petPhotoPreviewImage.removeAttribute('src');
      petPhotoPreviewImage.hidden = true;
      petPhotoPlaceholder.setAttribute('hidden', '');

      if (photoError()) return;

      const extension = petPhoto.files[0].name.split('.').pop().toLowerCase();
      if (!['jpg', 'jpeg', 'png', 'webp'].includes(extension)) {
        petPhotoPlaceholder.removeAttribute('hidden');
        return;
      }

      petPhotoPreviewUrl = URL.createObjectURL(petPhoto.files[0]);
      petPhotoPreviewImage.src = petPhotoPreviewUrl;
      petPhotoPreviewImage.hidden = false;
      petPhotoPlaceholder.setAttribute('hidden', '');
    };

    const setCurrentVariant = (variant) => {
      if (!variant) return;
      variantInput.value = variant.id;
      if (variantSelect) variantSelect.value = variant.id;
      price.textContent = formatMoney(variant.price, container.dataset.moneyFormat, container.dataset.currency);
      const pdpOffer = container.querySelector('[data-floopilo-pdp-offer]');
      if (pdpOffer) pdpOffer.dataset.priceCents = String(variant.price);
      container.dispatchEvent(new CustomEvent('floopilo:offer-price', { bubbles: true, detail: { priceCents: variant.price } }));
      updateSubmitAvailability();
      submitText.textContent = variant.available ? submitButton.dataset.addLabel : submitButton.dataset.soldOutLabel;
    };

    const updateVariant = () => {
      if (!variantSelect) return;
      setCurrentVariant(variants.find((item) => String(item.id) === variantSelect.value));
    };

    const renderGallery = (preserveMainImage = false) => {
      const image = activeGallery[activeImageIndex];
      if (!mainImage) return;

      if (!image) {
        if (defaultMainImage) {
          if (defaultMainImage.srcset) mainImage.setAttribute('srcset', defaultMainImage.srcset);
          else mainImage.removeAttribute('srcset');
          if (defaultMainImage.sizes) mainImage.setAttribute('sizes', defaultMainImage.sizes);
          else mainImage.removeAttribute('sizes');
          mainImage.src = defaultMainImage.src;
          mainImage.alt = defaultMainImage.alt || '';
          mainImage.style.objectFit = defaultMainImage.fit || 'cover';
          mainImage.style.objectPosition = defaultMainImage.position || 'center center';
        }
        if (galleryThumbnails) {
          galleryThumbnails.replaceChildren();
          galleryThumbnails.hidden = true;
        }
        if (galleryPrevious) galleryPrevious.hidden = true;
        if (galleryNext) galleryNext.hidden = true;
        return;
      }

      if (!preserveMainImage) {
        if (image.srcset) mainImage.setAttribute('srcset', image.srcset);
        else mainImage.removeAttribute('srcset');
        if (image.sizes) mainImage.setAttribute('sizes', image.sizes);
        else mainImage.removeAttribute('sizes');
        mainImage.src = image.src;
        mainImage.alt = image.alt || '';
        mainImage.style.objectFit = image.fit || 'cover';
        mainImage.style.objectPosition = image.position || 'center center';
      }

      if (galleryThumbnails) {
        galleryThumbnails.replaceChildren();
        const thumbnailItems = isDesignMode ? activeGallerySlots : activeGallery;
        thumbnailItems.forEach((galleryImage, index) => {
          if (!galleryImage.src) {
            const placeholder = document.createElement('span');
            placeholder.className = 'floopilo-v2-product__thumbnail-placeholder';
            placeholder.textContent = `${galleryImage.label} slot`;
            galleryThumbnails.append(placeholder);
            return;
          }

          const galleryImageIndex = activeGallery.findIndex((image) => image.src === galleryImage.src);
          const thumbnail = document.createElement('button');
          const thumbnailImage = document.createElement('img');
          thumbnail.className = 'floopilo-v2-product__thumbnail';
          thumbnail.type = 'button';
          thumbnail.setAttribute('aria-label', `View ${galleryImage.label || `image ${index + 1}`}`);
          thumbnail.setAttribute('aria-pressed', String(galleryImageIndex === activeImageIndex));
          thumbnail.addEventListener('click', () => {
            activeImageIndex = galleryImageIndex;
            renderGallery();
          });
          thumbnailImage.loading = 'lazy';
          thumbnailImage.src = galleryImage.thumbnail || galleryImage.src;
          thumbnailImage.alt = '';
          thumbnailImage.style.objectFit = galleryImage.fit || 'cover';
          thumbnailImage.style.objectPosition = galleryImage.position || 'center center';
          thumbnail.append(thumbnailImage);
          galleryThumbnails.append(thumbnail);
        });
        galleryThumbnails.hidden = activeGallery.length < 2 && !isDesignMode;
      }

      if (galleryPrevious) galleryPrevious.hidden = activeGallery.length < 2;
      if (galleryNext) galleryNext.hidden = activeGallery.length < 2;
    };

    const selectDesignGallery = (designId, preserveMainImage = false) => {
      const gallery = designGalleries.find((group) => group.id === designId);
      const gallerySlots = designGallerySlots.find((group) => group.id === designId);
      activeGallery = gallery ? gallery.images : [];
      activeGallerySlots = gallerySlots ? gallerySlots.slots : [];
      activeImageIndex = 0;
      renderGallery(preserveMainImage);
    };

    const visibleCoasterDesigns = () => coasterDesigns.filter((design) => !design.hidden);

    const setCoasterQuantities = (quantities) => {
      visibleCoasterDesigns().forEach((design, index) => {
        design.querySelector('[data-v2-mix-quantity]').textContent = String(quantities[index] || 0);
      });
    };

    const coasterQuantities = () => visibleCoasterDesigns().map((design) => Number(design.querySelector('[data-v2-mix-quantity]').textContent));

    const updateCoasterSetSelector = () => {
      if (!coasterSetSelector || !isCoasterMix) return;

      coasterSetSelector.hidden = !hasCoasterSetVariants;
      if (!hasCoasterSetVariants) return;

      const baseVariant = coasterVariantsBySize.get(4);
      coasterSetOptions.forEach((option) => {
        const setSize = Number(option.dataset.v2CoasterSetOption);
        const variant = coasterVariantsBySize.get(setSize);
        const price = option.querySelector('[data-v2-coaster-set-price]');
        const detail = option.querySelector('[data-v2-coaster-set-detail]');
        const selected = setSize === coasterSetSize;

        option.disabled = !variant?.available;
        option.setAttribute('aria-pressed', String(selected));
        if (price && variant) price.textContent = formatMoney(holidayPriceCents(variant.price), container.dataset.moneyFormat, container.dataset.currency);
        if (!detail || !variant || !baseVariant) return;
        if (setSize === 4) detail.textContent = copy('v2CoasterSet4Detail', 'The classic set');
        if (setSize === 5) detail.textContent = copy('v2CoasterSet5Detail', 'Add 1 extra for just {price}').replace('{price}', formatMoney(holidayPriceCents(variant.price) - holidayPriceCents(baseVariant.price), container.dataset.moneyFormat, container.dataset.currency));
        if (setSize === 6) detail.textContent = copy('v2CoasterSet6Detail', 'Add 2 extras for just {price} each').replace('{price}', formatMoney((holidayPriceCents(variant.price) - holidayPriceCents(baseVariant.price)) / 2, container.dataset.moneyFormat, container.dataset.currency));
      });
    };

    const resetCoasterMix = (themeKey) => {
      if (!isCoasterMix) return;

      coasterDesigns.forEach((design) => {
        design.hidden = design.dataset.v2ThemeKey !== themeKey;
      });
      setCoasterQuantities(defaultCoasterQuantities(visibleCoasterDesigns().length, coasterSetSize));
      updateCoasterMix();
    };

    const updateCoasterMix = () => {
      if (!isCoasterMix) return;

      const visibleDesigns = visibleCoasterDesigns();
      if (mixDesigns) mixDesigns.dataset.v2DesignCount = String(visibleDesigns.length);
      const total = visibleDesigns.reduce((sum, design) => sum + Number(design.querySelector('[data-v2-mix-quantity]').textContent), 0);
      if (mixTotal) mixTotal.textContent = copy('v2MixCounterFormat', '{selected}/{total}').replace('{selected}', String(total)).replace('{total}', String(coasterSetSize));
      visibleDesigns.forEach((design) => {
        design.querySelector('[data-v2-mix-action="increment"]').disabled = total >= coasterSetSize;
        design.querySelector('[data-v2-mix-action="decrement"]').disabled = Number(design.querySelector('[data-v2-mix-quantity]').textContent) === 0;
      });
      updateCoasterSetSelector();
      if (!mixProperties) return;

      mixProperties.replaceChildren();
      const setSize = document.createElement('input');
      setSize.type = 'hidden';
      setSize.name = 'properties[Set Size]';
      setSize.value = `${coasterSetSize} Coasters`;
      mixProperties.append(setSize);
      buildCoasterProperties(visibleDesigns.map((design) => ({
        name: design.dataset.v2DesignName,
        quantity: design.querySelector('[data-v2-mix-quantity]').textContent,
      }))).forEach(({ name, value }) => {
        const property = document.createElement('input');
        property.type = 'hidden';
        property.name = name;
        property.value = value;
        mixProperties.append(property);
      });
    };

    const validate = () => {
      const design = form.querySelector('[data-v2-field="design"]:checked');
      const selectedVariant = variants.find((item) => String(item.id) === variantInput.value);
      const errors = [];

      ['design', 'mix', 'pet-name', 'pet-photo'].forEach(resetField);

      if (!design) {
        const message = isCoasterMix ? copy('v2ErrorTheme', 'Choose a theme.') : copy('v2ErrorDesign', 'Choose a design.');
        errors.push(message);
        showFieldError('design', message);
      }
      if (isCoasterMix && (!design || coasterQuantities().reduce((sum, quantity) => sum + quantity, 0) !== coasterSetSize)) {
        const message = copy('v2ErrorMix', 'Choose exactly {count} coasters.').replace('{count}', String(coasterSetSize));
        errors.push(message);
        showFieldError('mix', message);
      }
      if (!selectedVariant) {
        errors.push(copy('v2ErrorVariant', 'This product option is not available.'));
      }
      if (!petName.value.trim()) {
        errors.push(copy('v2ErrorNameRequired', "Enter your pet's name."));
        showFieldError('pet-name', copy('v2ErrorNameRequired', "Enter your pet's name."));
      } else if (hasInvalidPetNameCharacters()) {
        errors.push(petNameCharacterMessage);
        showFieldError('pet-name', petNameCharacterMessage);
      } else if (countPetNameUnits(petName.value) > petNameUnitLimit) {
        errors.push(petNameLimitMessage);
        showFieldError('pet-name', petNameLimitMessage);
      }
      const petPhotoError = photoError();
      if (petPhotoError) {
        errors.push(petPhotoError);
        showFieldError('pet-photo', petPhotoError);
      }

      errorSummary.hidden = errors.length === 0;
      errorSummary.textContent = errors.join(' ');
      return errors.length === 0;
    };

    form.addEventListener(
      'submit',
      (event) => {
        if (validate()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        const firstInvalid = form.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      },
      true
    );

    form.querySelectorAll('[data-v2-field]').forEach((field) => {
      field.addEventListener('change', () => {
        if (field.dataset.v2Field === 'pet-name') {
          normalizePetName();
          return;
        }
        resetField(field.dataset.v2Field);
        if (field.dataset.v2Field === 'pet-photo') {
          const photoSelectionError = updatePetPhotoStatus();
          updatePetPhotoPreview();
          if (photoSelectionError) showFieldError('pet-photo', photoSelectionError);
        }
      });
      field.addEventListener('input', () => {
        if (field.dataset.v2Field === 'pet-name') {
          if (!isComposingPetName) normalizePetName();
          return;
        }
        resetField(field.dataset.v2Field);
      });
    });

    if (petName) {
      petName.addEventListener('compositionstart', () => {
        isComposingPetName = true;
      });
      petName.addEventListener('compositionend', () => {
        isComposingPetName = false;
        normalizePetName();
      });
    }

    if (galleryPrevious) {
      galleryPrevious.addEventListener('click', () => {
        if (activeGallery.length < 2) return;
        activeImageIndex = (activeImageIndex - 1 + activeGallery.length) % activeGallery.length;
        renderGallery();
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', () => {
        if (activeGallery.length < 2) return;
        activeImageIndex = (activeImageIndex + 1) % activeGallery.length;
        renderGallery();
      });
    }

    const galleryMedia = container.querySelector('[data-v2-main-image]');
    let touchStartX = null;
    if (galleryMedia) {
      galleryMedia.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      galleryMedia.addEventListener('touchend', (event) => {
        if (touchStartX === null || activeGallery.length < 2) return;
        const distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 40) return;
        activeImageIndex = distance > 0
          ? (activeImageIndex - 1 + activeGallery.length) % activeGallery.length
          : (activeImageIndex + 1) % activeGallery.length;
        renderGallery();
      }, { passive: true });
    }

    form.querySelectorAll('[data-v2-field="design"]').forEach((design) => {
      design.addEventListener('change', () => {
        if (design.checked) {
          selectDesignGallery(design.dataset.v2DesignId);
          resetCoasterMix(design.dataset.v2ThemeKey);
          if (selectedDesignName) selectedDesignName.textContent = design.value;
          if (designIdProperty) designIdProperty.value = design.dataset.v2DesignRecordId || '';
        }
      });
    });

    coasterDesigns.forEach((design) => {
      design.querySelectorAll('[data-v2-mix-action]').forEach((button) => {
        button.addEventListener('click', () => {
          const quantity = design.querySelector('[data-v2-mix-quantity]');
          const total = visibleCoasterDesigns().reduce(
            (sum, item) => sum + Number(item.querySelector('[data-v2-mix-quantity]').textContent),
            0
          );
          const next = button.dataset.v2MixAction === 'increment'
            ? Math.min(coasterSetSize, Number(quantity.textContent) + (total < coasterSetSize ? 1 : 0))
            : Math.max(0, Number(quantity.textContent) - 1);
          quantity.textContent = String(next);
          resetField('mix');
          updateCoasterMix();
        });
      });
    });

    const changeCoasterSetSize = (nextSize) => {
      if (!hasCoasterSetVariants || ![4, 5, 6].includes(nextSize)) return;
      const nextVariant = coasterVariantsBySize.get(nextSize);
      if (!nextVariant?.available) return;
      setCoasterQuantities(resizeCoasterMix(coasterQuantities(), nextSize));
      coasterSetSize = nextSize;
      setCurrentVariant(nextVariant);
      resetField('mix');
      updateCoasterMix();
    };

    coasterSetOptions.forEach((option) => {
      option.addEventListener('click', () => changeCoasterSetSize(Number(option.dataset.v2CoasterSetOption)));
    });

    const selectedDesign = form.querySelector('[data-v2-field="design"]:checked');
    if (isCoasterMix && hasCoasterSetVariants) setCurrentVariant(coasterVariantsBySize.get(4));
    if (selectedDesign) {
      selectDesignGallery(selectedDesign.dataset.v2DesignId, true);
      resetCoasterMix(selectedDesign.dataset.v2ThemeKey);
      if (selectedDesignName) selectedDesignName.textContent = selectedDesign.value;
      if (designIdProperty) designIdProperty.value = selectedDesign.dataset.v2DesignRecordId || '';
    }

    placeWhyPanel();
    desktopLayout.addEventListener('change', placeWhyPanel);
    normalizePetName();
    updatePetPhotoStatus();
    updatePetPhotoPreview();

    form.querySelectorAll('[data-v2-photo-change]').forEach((button) => {
      button.addEventListener('click', () => petPhoto.click());
    });

    if (nameGuideToggle && nameGuide) {
      const closeNameGuide = (returnFocus = false) => {
        nameGuide.hidden = true;
        nameGuideToggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) nameGuideToggle.focus();
      };

      nameGuideToggle.addEventListener('click', () => {
        const opening = nameGuide.hidden;
        nameGuide.hidden = !opening;
        nameGuideToggle.setAttribute('aria-expanded', String(opening));
      });
      container.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !nameGuide.hidden) closeNameGuide(true);
      });
      document.addEventListener('pointerdown', (event) => {
        if (nameGuide.hidden || (nameFieldset && nameFieldset.contains(event.target))) return;
        closeNameGuide();
      });
    }

    if (photoGuideToggle && photoGuide) {
      const closePhotoGuide = (returnFocus = false) => {
        photoGuide.hidden = true;
        photoGuideToggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) photoGuideToggle.focus();
      };

      photoGuideToggle.addEventListener('click', () => {
        if (!photoGuide.hidden) {
          closePhotoGuide();
          return;
        }

        photoGuide.hidden = false;
        photoGuideToggle.setAttribute('aria-expanded', 'true');
      });
      container.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || photoGuide.hidden) return;
        closePhotoGuide(true);
      });
      document.addEventListener('pointerdown', (event) => {
        if (photoGuide.hidden || (photoUpload && photoUpload.contains(event.target))) return;
        closePhotoGuide();
      });
    }

    window.addEventListener('pagehide', () => {
      if (petPhotoPreviewUrl) URL.revokeObjectURL(petPhotoPreviewUrl);
    }, { once: true });

    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
  });
})();
